import createActions from 'utils/redux/createActions'

export default createActions([
  'OPEN_PANEL',
  'CLOSE_PANEL',
  'TRIGGER_PROMPT'
])



// WEBPACK FOOTER //
// ./src/actions/rightStackActions.js